import { gsap } from "gsap"

class Cursor {
    constructor() {
        this.cursor = [...document.querySelectorAll('.not-touch [data-cursor]')]
        if (this.cursor.length === 0) {
            // stop code
            return
        }
        this.tweenVars = { duration: .5, ease: "power3" }
        this.xTo = gsap.quickTo(this.cursor, "x", this.tweenVars)
        this.yTo = gsap.quickTo(this.cursor, "y", this.tweenVars)
        this.animationDuration = 190

        gsap.set(this.cursor, { xPercent: -50, yPercent: -50 });



        this.init()
        this.setupLinkListeners()
    }

    init() {
        window.addEventListener("mousemove", e => {
            this.xTo(e.clientX)
            this.yTo(e.clientY)
        }, { passive: true })


    }

    setupLinkListeners() {
        this.cursor.forEach(cursor => {
            const link = cursor.closest('a')
            if (link && link.href) {
                const isExternal = link.target == '_blank'
                const isModal = link.closest('[href*="#modal-"]')

                cursor.classList.remove('cursor--play'),
                    cursor.firstChild.addEventListener("animationend", () => {

                        if (this.isSafari()) {
                            // prevent it to flagged it as a popup
                            link.target = '_top'
                        }

                        if (isModal) {
                            this.showModal(new URL(link.href).hash.slice(1))
                        } else {
                            link.dispatchEvent(new MouseEvent('click',
                                {
                                    cancelable: false
                                }
                            ))
                        }

                        if (isExternal || isModal) {
                            cursor.classList.remove('cursor--play')
                            cursor.classList.add('cursor--reset')
                            void cursor.offsetWidth
                            cursor.classList.remove('cursor--reset')
                        }

                    }),
                    link.addEventListener("click", e => {

                        e.stopPropagation()
                        e.preventDefault()
                        cursor.classList.add('cursor--play')
                    })
            }
        })
    }

    isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    }


    showModal(id) {
        const modal = document.getElementById(id)
        if (!modal || modal.nodeName !== 'DIALOG') return

        if (!modal.open) {
            modal.showModal()
        }
    }

}

export default Cursor